import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Breadcrumb from "../../components/Breadcrumb";
import CTA from "../../components/CTA";
import SingleProject from "../../components/Project";
import { projectsData, getProjectsByCategory } from "./ProjectData";

import bgImg from "../../assets/img/cta/cta-bg-2.png";

// Make data available globally for ProjectDetails
window.projectsData = projectsData;

const ProjectOneMain = () => {
  let tab1 = "All Projects",
    tab2 = "Mobile Apps",
    tab3 = "Web Applications",
    tab4 = "Business Systems";
  const tabStyle =
    "nav justify-content-center project-2__button-box masonary-menu";

  const [open, setOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);

  // Handler for image gallery
  const handleClick = (images) => {
    setLightboxImages(images.map((img) => ({ src: img })));
    setOpen(true);
  };

  // Function to render projects for each tab
  const renderProjects = (category) => {
    const projects = getProjectsByCategory(category);

    return (
      <TabPanel className="row">
        {projects.map((project, index) => {
          const isMobile = project.platform === "Mobile";

          return (
            <div
              key={project.id}
              className="col-12 col-md-6 mb-4"
            >
              <SingleProject
                Image={project.mainImage}
                Title={project.title}
                categoryOne={project.platform}
                categoryTwo={project.category}
                onClickHandler={() => handleClick(project.images)}
                isMobileApp={isMobile}
              />
            </div>
          );
        })}
      </TabPanel>
    );
  };

  return (
    <main>
      <Breadcrumb pageTitle="My Projects" />

      <>
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={lightboxImages}
        />
        <div className="project-2__area project-2__plr project-2__space p-relative">
          <div className="container-fluid">
            <Tabs>
              <div className="row">
                <div
                  className="col-xl-12 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".7s"
                >
                  <TabList className={tabStyle}>
                    <Tab>
                      <button>{tab1}</button>
                    </Tab>
                    <Tab>
                      <button>{tab2}</button>
                    </Tab>
                    <Tab>
                      <button>{tab3}</button>
                    </Tab>
                    <Tab>
                      <button>{tab4}</button>
                    </Tab>
                  </TabList>
                </div>
              </div>

              {/* All Projects Tab */}
              {renderProjects("All Projects")}

              {/* Mobile Apps Tab */}
              {renderProjects("Mobile Apps")}

              {/* Web Applications Tab */}
              {renderProjects("Web Applications")}

              {/* Business Systems Tab */}
              {renderProjects("Business Systems")}

              <div className="row justify-content-center">
                <div className="col-xl-7">
                  <div className="button text-center pt-50">
                    <Link
                      className="main-btn tp-btn-hover alt-color"
                      to="/contact"
                    >
                      <span>Let's Discuss Your Project</span>
                      <b></b>
                    </Link>
                  </div>
                </div>
              </div>
            </Tabs>
          </div>
        </div>
      </>

      <CTA
        ctaBG={bgImg}
        Title="Have a Similar Project in Mind?"
        Description="I create custom business solutions that solve real operational challenges. Let's discuss how I can help streamline your business processes with modern React and React Native applications."
        btnText="Discuss My Project"
        btnURL="contact"
      />
    </main>
  );
};

export default ProjectOneMain;
